'use client';

import styles from './page.module.css';
import './DetailsBlock.css';
import { IDetailsBlock } from '../types';

const DetailsBlockClient: React.FC<IDetailsBlock> = ({ content, staticText }) => {
  const makeScroll = () => {
    const gallery = document.querySelector('.pageGallery');
    if (gallery) {
      gallery.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className={`details projectWrapper`}>
      <h2 className={styles.details__title}>
        {content.title ? content.title : staticText.aboutProjectTitle}
      </h2>
      <div className={styles.details__container}>
        {content.projectDetails.map(i => (
          <div className={styles.details__itemContainer} key={i.id}>
            <span className={styles.details__itemTopic}>{i.topic}</span>
            <span className={styles.details__itemDetails}>{i.details}</span>
          </div>
        ))}
      </div>
      <button className={styles.details__scroll} onClick={makeScroll}>
        {staticText.goToGalleryButton}
      </button>
    </section>
  );
};

export default DetailsBlockClient;
